// extracted by mini-css-extract-plugin
export var openReturn = "wHleM_4EFcVJqSdCbNJZ";
export var root = "WOtYoUS3WvShsWiKNZKq";